import canShowFunMode from '~/shared/utils/canShowFunMode';
import ClappsToggle from '../../../../shared/ClappsToggle';
import FullscreenToggle from '../FullscreenToggle';
import FunModeToggle from '../FunModeToggle';
import UserFooter from '../UserFooter';

type Props = {
  game: GameFragment | undefined;
};

const StandardGamesFooter: FC<Props> = ({ game }) => (
  <div
    className="flex h-14 w-full items-center justify-between"
    data-testid="game-footer"
  >
    <UserFooter />
    <div className="hidden sm:inline-container gap-4">
      <ClappsToggle />
      {canShowFunMode(game) && <FunModeToggle />}
      <FullscreenToggle />
    </div>
  </div>
);

export default StandardGamesFooter;
